// src/services/api/boltJr/heroApi.ts
import { createApiService } from '../base';
import { BoltHeroItem } from '../../../types/bolt-jr';

const heroService = createApiService<BoltHeroItem>('hero', 'bolt-jr');

export const fetchHeroItems = heroService.getAll;
export const fetchHeroItem = heroService.getOne;
export const createHeroItem = heroService.create;
export const updateHeroItem = heroService.update;
export const deleteHeroItem = heroService.delete;
export const updateHeroItemsOrder = heroService.updateOrder;
